<template>
  <div>
    <i class="b2b-grid__icon material-icons"
      @click="expandRow"
      ref="">
      add_box
    </i>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  data() {
    return {

    }
  },
  inject: ['item'],
  methods: {
    expandRow() {
      console.log('expandRow()');
      this.item.rowData.expanded = !this.item.rowData.expanded;
    }
  }
}
</script>
